import { ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'

// A presigned download URL for a Drive object. App-level, not Drive's: the
// shared file preview (contexts/file-preview) and usePresignedGetUrl read it,
// and a shared layer may not import a feature module (#33). The Drive package
// (packages/drive) has its own copy of this one call.
export const PresignedGetUrl = async (
    path: string
): Promise<ResponseObject<string>> => {
    const response = await datacentral.get('/drive/download', {
        params: { path: path },
    })
    return response.data
}
